export default {
    reply: '回复',
    noData: 'No data',
    hour: 'hour ',
    minute: 'score ',
    years: '-',
    months: '-',
    day: '',
    operation: {
        title: 'operation',
        boardName: 'data-board',
        totalVisit: '累计访问用户',
    },
};
